import { GANGSTABET_PRODUCT } from "@constants/images";
const TopBanner = () => {
  return (
    <div>
      <div className="topBanner-gangstabet">
        <img src={GANGSTABET_PRODUCT.LOGO} alt="gangstabet logo" />
      </div>
      <div className="topBanner-text">
      GangstaBet was inspired by the classic gangster movies from the 90s, entailing a constant battle between gangsters and detectives. Each character tells a unique story about their life as they try to climb to the helm. From a casino worker to a mob boss, or a junior detective to a chief constable, GangstaBet writes their entire journey on the blockchain.
      </div>
    </div>
  );
};

export default TopBanner;
